import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import {
  CountryStateListQueryParams,
  CountryStateListResponseData,
} from "../../types/enum";
import { toQueryString } from "../../../common/utils";

export const getData = async (params: CountryStateListQueryParams) => {
  const { data } = await api.get<CountryStateListResponseData>(
    `/country-states${toQueryString(params)}`,
  );

  return data;
};

export const useCountryStates = (
  params: CountryStateListQueryParams,
): QueryObserverBaseResult<CountryStateListResponseData> => {
  const { data, ...props } = useQuery(
    queryKeys.countryStates(params),
    () => getData(params),
    { enabled: !!params.fCountryId },
  );

  return { data, ...props };
};
